// Blueprint: forge/blueprint/frontend/architecture/001-shell-composition.md
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { Button } from '@servicetitan/anvil2';
import { NoAccessMessage } from 'org-hub-shared';

import { AuthStore } from '../common/stores/auth.store';

import sidebarSvg from '../common/assets/sidebar.svg';
import STLogo from '../common/assets/st-logo.svg?component';

import * as Styles from './auth-module.module.scss';

/*
 * Shown to a signed-in user whose org does not have Org Hub enabled (`/api/me` answered 403 by the API's
 * OrgHub.IsEnabled access gate). Same brand-panel layout as the sign-in surface; the only action is a full
 * RP-initiated sign-out so the user can switch to an account that has access.
 */
export const NoAccessModule = observer(() => {
    const [{ logout, deniedOrgName }] = useDependencies(AuthStore);

    return (
        <div className={Styles.signinPageContainer} data-testid="org-hub-no-access">
            <div className={Styles.sidebarContainer}>
                <img src={sidebarSvg} className={Styles.sidebarSvg} alt="" />
            </div>
            <div className={Styles.signinPageContent}>
                <STLogo className={Styles.stLogo} />
                <NoAccessMessage orgName={deniedOrgName}>
                    <Button
                        className={Styles.signinBtn}
                        appearance="primary"
                        onClick={logout}
                        data-testid="no-access-logout-button"
                    >
                        Sign out
                    </Button>
                </NoAccessMessage>
            </div>
        </div>
    );
});
